<template>
  <div id="orgRegisterStepFour">
    <div class="form-box">
      <div class="form-title">
        <span>注册成功</span>
        <span class="title-right"> LOGIN SUCCESSFUL</span>
      </div>
      <div class="successImg">欢迎您注册易比得合规采购平台！</div>
      <div class="successMessage">我们已经收到您的注册申请，并提交运营方审核。审核时间预计需要3个工作日。审核完成后，将给您发送邮件以及短信通知。关于易比得有任何问题、意见以及建议，欢迎您和我们联系：</div>
      <div class="userInfo">
        <div class="userInfoRow">
          <div class="userInfoRow-left">易比得支持邮件</div>
          <div class="userInfoRow-middle">:</div>
          <div class="userInfoRow-right">service@360bid.cn</div>
        </div>
        <div class="userInfoRow">
          <div class="userInfoRow-left">易比得服务热线</div>
          <div class="userInfoRow-middle">:</div>
          <div class="userInfoRow-right">18614005157</div>
        </div>
        <div class="userInfoRow">
          <div class="userInfoRow-left">易比得微信公众号</div>
          <div class="userInfoRow-middle">:</div>
          <div class="userInfoRow-right">易比得</div>
        </div>
        <div class="userInfoRow">
          <div class="userInfoRow-left">易比得服务微信</div>
          <div class="userInfoRow-middle">:</div>
          <div class="userInfoRow-right">搜索电话号码 18614005157</div>
        </div>
      </div>
      <router-link to="/portal">
        <el-button class="eb-button-orange submitForm">返回首页</el-button>
      </router-link>
    </div>

  </div>
</template>
<script>
export default {
  name: 'OrgRegisterStepFour'
};
</script>
<style scoped lang="less">
#orgRegisterStepFour {
  font-family: 'Microsoft YaHei';
  position: relative;
  .register-bg {
    position: absolute;
    width: 181px;
    top: 156px;
    left: 150px;
  }
  .leftText {
    position: absolute;
    top: 561px;
    left: 521px;
    color: #fb5b3b;
    text-align: right;
    font-size: 18px;
    line-height: 28px;
    .leftText-one {
      font-size: 48px;
      line-height: 65px;
    }
  }
  .form-box {
    height: 580px;
    width: 441px;
    background-color: #fff;
    position: absolute;
    top: 56px;
    right: 433px;
    box-shadow: 6px 6px 6px #939393;
    padding: 25px;
    .form-title {
      color: #fb5b3b;
      font-size: 24px;
      margin-bottom: 38px;
      .title-right {
        color: #a7a6a6;
        font-size: 14px;
      }
    }
    .successImg {
      height: 80px;
      padding-top: 82px;
      padding-left: 106px;
      background: url(../../../assets/img/register-success.jpg) no-repeat 36px 50px;
      font-size: 18px;
      font-weight: bold;
    }
    .successMessage {
      width: 343px;
      color: #6b6b6b;
      padding-left: 37px;
      line-height: 30px;
    }
    .userInfo {
      padding-bottom: 57px;
      .userInfoRow {
        display: flex;
        padding-left: 36px;
        line-height: 30px;
      }
      .userInfoRow-left {
        font-weight: bold;
        width: 120px;
      }
      .userInfoRow-middle {
        font-weight: bold;
        padding-right: 2px;
      }
      .userInfoRow-right {
        color: #fb5b3b;
      }
    }
    .submitForm {
      height: 40px;
    }
  }
}
</style>
